export function setParam(name: string, value: string) {
	const url = new URL(window.location.toString());
	url.searchParams.set(name, value);

	// eslint-disable-next-line no-restricted-globals
	history.pushState({}, '', url.toString());
}

export default setParam;
